import { gql, useMutation } from "@apollo/client";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

import { ApiKeysQuery, DeleteApiKeyMutation } from "~/graphql/__generated__/graphql";

type Props = {
  keyToDelete: ApiKeysQuery["apiKey"][number],
  onClose: () => void,
}

const DeleteKeyDialog = ({ keyToDelete, onClose }: Props) => {
  const [deleteApiKey, { loading: deleteApiKeyLoading }] = useMutation<DeleteApiKeyMutation>(DELETE_API_KEY_MUTATION, {
    refetchQueries: ["ApiKeys"]
  });

  return <Dialog open={!!keyToDelete} onClose={onClose}>
    <DialogTitle>Delete API Key</DialogTitle>
    <DialogContent>
      <Typography>
        Are you sure you want to delete the API key {keyToDelete.apiKey}? This action cannot be undone.
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button color="error" loading={deleteApiKeyLoading} onClick={async () => {
        await deleteApiKey({
          variables: {
            id: keyToDelete.id,
          },
        });
        onClose();
      }}>
        Delete
      </Button>
    </DialogActions>
  </Dialog>
}

export default DeleteKeyDialog;

const DELETE_API_KEY_MUTATION = gql`
  mutation DeleteApiKey($id: Int!)
  @permission(requires: manageApiKeys) {
    deleteApiKey(id: $id) {
      id
      apiKey
    }
  }
`;
